import { render, staticRenderFns } from "./LinhasDeProdutosEditar.vue?vue&type=template&id=28a2b9d0"
import script from "./LinhasDeProdutosEditar.vue?vue&type=script&lang=js"
export * from "./LinhasDeProdutosEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports